"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const libphonenumber_js_1 = require("libphonenumber-js");
const validator_1 = require("validator");
const constants_1 = require("../src/constants");
/**
 * Returns 'US' from 'en-US' standard
 * @param locale 'en-US' similar string
 * @author Arman Mkrtchyan
 */
exports.localeToCountryCode = locale => {
    return locale.split('-')[1];
};
/**
 * Returns mapped 'en-US' standard locale code string from 'America/Los_Angeles',
 * hardcoded for Sydney for now
 * @param timezoneName 'Australia/Sydney' standard string
 * @author Arman Mkrtchyan
 */
function getLocaleFromTimezone(timezoneName) {
    return constants_1.timezoneToLocaleMap[timezoneName] || constants_1.LocaleEnum.US;
}
exports.getLocaleFromTimezone = getLocaleFromTimezone;
/**
 * True if passed phoneNumber is ISO164 standard (+15555551100), ignoring whitespaces
 * @param phoneNumber
 * @author Arman Mkrtchyan
 */
function isPhoneE164(phoneNumber) {
    const parsed = libphonenumber_js_1.default(phoneNumber);
    return !!parsed && parsed.number === phoneNumber.replace(/\s/g, '');
}
exports.isPhoneE164 = isPhoneE164;
/**
 * Strips whitespaces id phonenumber is E164 or calls reformatPhoneNumber otherwise
 * @param phoneNumber
 * @param locale 'en-US' standard locale code string
 * @author Arman Mkrtchyan
 */
function cleanE164OrReformatPhoneNumber(phoneNumber, locale) {
    if (isPhoneE164(phoneNumber)) {
        return {
            phone: phoneNumber.replace(/\s/g, ''),
            isValid: true
        };
    } else {
        return exports.reformatPhoneNumber(phoneNumber, locale);
    }
}
exports.cleanE164OrReformatPhoneNumber = cleanE164OrReformatPhoneNumber;
function updateAppearance(appearance) {
    if (!appearance) {
        return;
    }
    Object.keys(appearance).map(key => {
        // @ts-ignore
        document.querySelector(':root').style.setProperty(key, appearance[key]);
    });
}
exports.updateAppearance = updateAppearance;
/**
 * Validates and Reformates to ISO164 non-whitespaced string based on locale string
 * @param phoneNumber
 * @param locale 'en-US' standard locale code string
 */
exports.reformatPhoneNumber = (phoneNumber, locale) => {
    let phone = phoneNumber.replace(/[^0-9]/g, '');
    let isValid = false;
    if (locale === constants_1.LocaleEnum.US) {
        if (validator_1.isMobilePhone(phone, locale)) {
            if (phone.length === constants_1.PhoneNumberLengthEnum.US_WITH_COUNTRY_CODE) {
                phone = `+${phone}`;
                isValid = true;
            } else if (phone.length === constants_1.PhoneNumberLengthEnum.US_WITHOUT_COUNTRY_CODE) {
                phone = `${constants_1.PhoneCountryCode.US}${phone}`;
                isValid = true;
            }
        }
    } else {
        const countryCode = exports.localeToCountryCode(locale);
        const parsed = libphonenumber_js_1.default(phoneNumber, countryCode);
        isValid = !!parsed && parsed.isValid() && countryCode === parsed.country;
        phone = parsed && parsed.number.replace(/\s/g, '');
    }
    return { phone, isValid };
};


//////////////////
// WEBPACK FOOTER
// ./client/common/index.ts
// module id = 636
// module chunks = 0 1 2